// extracted by mini-css-extract-plugin
export var details = "_fr-0";
export var inspectorPopover = "_fr-1";